import { render, staticRenderFns } from "./PDPSearch.vue?vue&type=template&id=872419c2&scoped=true&"
import script from "./PDPSearch.vue?vue&type=script&lang=js&"
export * from "./PDPSearch.vue?vue&type=script&lang=js&"
import style0 from "./PDPSearch.vue?vue&type=style&index=0&id=872419c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872419c2",
  null
  
)

export default component.exports